import React from 'react'
import { Collection, ForEachModel, Model, WhenCollectionIsNotEmpty, WhenModel } from '@morningtrain/react-resources'
import * as Filters from 'support/filters'
import { EnumFilter, SelectedDepartmentFilter, UserFilter } from 'support/filters'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import OnboardingListView from './partials/OnboardingListview'
import { Link } from '@morningtrain/react-navigation'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { PaginationFilter } from '@morningtrain/react-filters'
import AdminPage from 'pages/app/AdminPage'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function OnboardingOverview () {
  const [myId] = useEnvValue('user.id')
  const [routeUserId] = useEnvValue('router.currentParameters.user')

  const userId = routeUserId || myId
  const isMine = myId === userId

  return (
    <AdminPage>
      <Translator namespace='onboarding'>

        <UI.PageHeader title={<TranslatedTitle name='titles.overview' />}>
          <UI.ButtonWrap>
            <Can permission={Permissions.ONBOARDING_CHECKLIST_TEMPLATES_MANAGE}>
              <Link route='app.onboarding.templates'>
                <UI.Button>
                  <UI.WithIcon size={5} placement='right' icon={<UI.Icons.Settings />}>
                    <Translation name='actions.manage_templates' />
                  </UI.WithIcon>
                </UI.Button>
              </Link>
            </Can>
          </UI.ButtonWrap>
        </UI.PageHeader>

        <Collection resourceName='onboarding.onboarding_checklists'>
          <SelectedDepartmentFilter />

          <Model resourceName='onboarding.onboarding_checklists' operationName='employee' id={userId} clean>
            <WhenModel>
              <UI.SecondaryHeading>
                <Translation name='titles.my_onboarding' />
              </UI.SecondaryHeading>
              <div className='mt-4 mb-8'>
                <OnboardingListView displayChecklists={false} user={userId} />
              </div>
            </WhenModel>
          </Model>

          <UI.CardGroup>

            <UI.SecondaryHeading>
              <Translation name='titles.employee_onboarding' />
            </UI.SecondaryHeading>

            <UI.TableHeader>
              <Translator name='onboarding.filters'>
                <EnumFilter
                  defaultValue={null}
                  enum="employment_type"
                  allowNull
                  name="employment_type"
                  label={<Translation name="filters.employment_type.label"/>}
                  placeholder="-"
                />
                <Filters.SwitchFilter
                  name="status"
                  enum="onboarding_checklist_status"
                  defaultValue="pending"
                  label={<Translation name="filters.onboarding_checklist_status.label"/>}
                />
                <UserFilter name='id' />
              </Translator>
            </UI.TableHeader>

            <WhenCollectionIsNotEmpty>
              <ForEachModel>
                <OnboardingListView displayChecklists={false} />
              </ForEachModel>
            </WhenCollectionIsNotEmpty>
            <PaginationFilter />
          </UI.CardGroup>
        </Collection>

      </Translator>
    </AdminPage>
  )
}
